import type {
  BrandingBackgroundMode,
  GetMenuAppRestaurantDataResponse,
  RestaurantBranding,
} from "api-types";

import { Theme } from "@mui/material";

import {
  CustomerMenuDefaultThemeProps,
  createDefaultTheme,
} from "../core/theme";

export type RestaurantBrandingAndTheme = {
  theme: Theme;
  backgroundMode?: BrandingBackgroundMode;
  backgroundImageUrl?: string;
  logoImageUrl?: string;
};

/**
 * Returns the RestaurantBranding for the given restaurant.
 *
 * This is the custom branding settings for the restaurant.
 */
export function createRestaurantBrandingAndTheme(
  restaurantData: GetMenuAppRestaurantDataResponse
): RestaurantBrandingAndTheme {
  if (!restaurantData.branding) {
    // no branding was returned by the API, use default theme
    return createNoBranding();
  }

  const branding = restaurantData.branding;
  return {
    theme: createThemeFromBranding(branding),
    backgroundMode: branding.backgroundMode || undefined,
    backgroundImageUrl: branding.backgroundImageUrl || undefined,
    logoImageUrl: branding.logoImageUrl || undefined,
  };
}

const createNoBranding = (): RestaurantBrandingAndTheme => {
  return {
    theme: createThemeFromBranding({}),
  };
};

const createThemeFromBranding = (branding: RestaurantBranding): Theme => {
  return createDefaultTheme({
    backgroundColor:
      branding.backgroundColor || CustomerMenuDefaultThemeProps.backgroundColor,
    accentColor: branding.accentColor,
    accentContrastColor: branding.accentContrastColor,
  });
};
